import React, { Component } from 'react';
import { fetchWithJson } from '../../utils/api';

import ReceivedCouponList from '../../components/ReceivedCouponList';

export default class ReceivedCouponsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      receivedCoupons: props.receivedCoupons || [],
      isFetching: false
    };

    this.getUsableCoupons = this.getUsableCoupons.bind(this);
    this.getUsedCoupons = this.getUsedCoupons.bind(this);
    this.getExpiredCoupons = this.getExpiredCoupons.bind(this);
  }

  componentDidMount() {
    this.setState({
      isFetching: true
    });
    fetchWithJson(`/api/talk/received_coupons`).then(result => {
      this.setState({
        receivedCoupons: result,
        isFetching: false
      });
    });
  }

  parseYIDCoupon(coupons) {
    return coupons.map((coupon) => {
      const page = coupon['page'];
      const detail = page['detail'];

      return {
        coupon: {
          title: detail['title'],
          author: {
            nickname: page['profileName']
          },
          content: detail['description'],
          entryImage: {
            mediumUrl: detail['imageUrl']
          },
          usedStartAt: page['startAt'],
          usedEndAt: page['endAt'],
          onlineFlag: !(page['couponType'] === 'offline'),
          permalink: coupon['permalink'],
          type: 'YID_coupon'
        },
        coupon_log: {
          used_at: coupon['pageCoupon']['modifiedAt']
        }
      }
    });
  }

  parseYIDCatalog(catalogs) {
    return catalogs.map((catalog) => {
      const page = catalog['page'];
      const couponJson = page['coupon'];

      return {
        coupon: {
          title: page['btnName'],
          author: {
            nickname: page['profileName']
          },
          entryImage: {
            mediumUrl: couponJson['btnImageUrl']
          },
          usedStartAt: couponJson['startAt'],
          usedEndAt: couponJson['endAt'],
          onlineFlag: !(couponJson['onlineBtnName'] == undefined),
          permalink: catalog['permalink'],
          type: 'YID_catalog_coupon'
        },
        coupon_log: {
          used_at: catalog['pageCatalogCoupon']['modifiedAt']
        }
      };
    });
  }

  getUsableCoupons() {
    const { receivedCoupons } = this.state;
    const usables = receivedCoupons.usable || [];
    const usableYIDCoupons = receivedCoupons.usableYIDCoupon || [];
    const usableYIDCatalogCoupons = receivedCoupons.usableYIDCatalogCoupon || [];

    return usables.concat(this.parseYIDCatalog(usableYIDCatalogCoupons))
                  .concat(this.parseYIDCoupon(usableYIDCoupons));
  }

  getUsedCoupons() {
    const { receivedCoupons } = this.state;
    const useds = receivedCoupons.used || [];
    const usedYIDCoupons = receivedCoupons.usedYIDCoupon || [];
    const usedYIDCatalogCoupons = receivedCoupons.usedYIDCatalogCoupon || [];

    return useds.concat(this.parseYIDCoupon(usedYIDCoupons))
                .concat(this.parseYIDCatalog(usedYIDCatalogCoupons));
  }

  getExpiredCoupons() {
    const { receivedCoupons } = this.state;
    const expireds = receivedCoupons.expired || [];
    const expiredYIDCoupons = receivedCoupons.expiredYIDCoupon || [];
    const expiredYIDCatalogCoupons = receivedCoupons.expiredYIDCatalogCoupon || [];

    return expireds.concat(this.parseYIDCoupon(expiredYIDCoupons))
                .concat(this.parseYIDCatalog(expiredYIDCatalogCoupons));
  }

  render() {
    const { type } = this.props;
    const { receivedCoupons, isFetching } = this.state;

    const usables = this.getUsableCoupons();
    const useds = this.getUsedCoupons();
    const expireds = this.getExpiredCoupons();

    const isEmpty = (usables.length + useds.length + expireds.length) === 0;

    return (
      <div className="wrap_coupon">
        {
          !isFetching && usables.length > 0 && (
            <ReceivedCouponList type={type} couponInfos={usables} showDDay={true} />
          )
        }
        {
          !isFetching &&useds.length > 0 && (
            <div>
              <strong className="coupon_line"><span className="coupon_term">사용 완료 쿠폰</span></strong>
              <ReceivedCouponList type={type} couponInfos={useds} showUsed={true} />
            </div>
          )
        }
        {
          !isFetching && expireds.length > 0 && (
            <div>
              <strong className="coupon_line"><span className="coupon_term">기간 만료 쿠폰</span></strong>
              <ReceivedCouponList type={type} couponInfos={expireds} showOutdated={true} />
            </div>
          )
        }
        {
          !isFetching && isEmpty && (
            <div className="wrap_coupon">
              <div>
                <span className="img_cont" />
                <strong className="tit_talk">받은 쿠폰이 없습니다.</strong>
                {type !== 'global' && (<span className="txt_desc">추천 쿠폰탭에서 쿠폰을 받아보세요.</span>)}
              </div>
            </div>
          )
        }

        {
          isFetching && (
            <div className="wrap_coupon">
              <div className="foot_coupon">
                <span className="ico_loading" />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/MorePage/receiveds.js